/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import AddCircleIcon from "@mui/icons-material/AddCircle";
// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// React-Select component and styling
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import MDButton from "components/MDButton";
import MDCard from "components/MDCard";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  approveVin,
  changeVin,
  createDispatch,
  createDynamicColumn,
  getAccessoriesByVin,
  getDynamicColumn,
  getFgCode,
  getFgCodeNoPagination,
  getSalesOrder,
  getSubModulesByRoleId,
  getVinByFgCodeForDispatch,
  getVinStatusByTripNo,
  releaseTrip,
} from "../../store";

//  some date function
import { addMinutes, format } from "date-fns";

// Cookies
import Cookies from "universal-cookie";

// config file
import Config from "../../config/index";
// Formik and Yup
import { Field, FieldArray, Form, Formik } from "formik";
// import { useFormik } from "formik";
// import * as Yup from "yup";
import CancelIcon from "@mui/icons-material/Clear";
import { Backdrop, CircularProgress } from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import ReleaseButton from "components/standardized-components/ReleaseButton";
import { CSVLink } from "react-csv";
import { ToastContainer } from "react-toastify";

const cookies = new Cookies();

const desLength = Config.descriptionLength;
const styleForCreate = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 920 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
  overflow: "scroll",
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",

  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 1200 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
  marginBottom: "200px",
  overflow: "scroll",
};

const styleForChangeVin = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};

const releaseStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Dispatch = ({
  getSalesOrder,
  getFgCode,
  getFgCodeNoPagination,
  salesOrder,
  getVinStatusByTripNo,
  vinStatus,
  releaseTrip,
  getVinByFgCodeForDispatch,
  getVinByFgCodeForDispatchReducer,
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
  getFgCodeReducer,
  getFgCodeNoPaginationReducer,
  createDispatch,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "05581efa-a80c-4e2f-bbbe-75fa2010ff49";

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let dispatchModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "05581efa-a80c-4e2f-bbbe-75fa2010ff49",
  );

  let viewAccess = dispatchModule
    ? dispatchModule.actionId.includes("d3803458-406c-4a8f-b4cd-103398559a6e")
    : null;

  let createAccess = dispatchModule
    ? dispatchModule.actionId.includes("51017fc7-7d50-4878-a92f-9ca47c627b73")
    : null;

  let releaseAccess = dispatchModule
    ? dispatchModule.actionId.includes("99dd6680-fd54-4a10-82be-7df604e3ebd3")
    : null;

  let replaceVinAccess = dispatchModule
    ? dispatchModule.actionId.includes("9872d1b0-2809-4a75-ab35-22b9a82c6344")
    : null;

  let downloadAllDataAccess = dispatchModule
    ? dispatchModule.actionId.includes("10b0a5d6-48db-4188-ba65-8f2f4eae4d42")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [statusSelected, setStatusSelected] = useState("");

  const handleStatusChange = (selectedOption) => {
    setStatusSelected(selectedOption);
  };

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Created",
      value: 0,
    },
    {
      label: "Not Picked",
      value: 1,
    },
    {
      label: "Picked",
      value: 2,
    },
    {
      label: "Delivered",
      value: 3,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "Sales Order No", accessor: "salesOrderNumber" },
      { Header: "Trip NUMBER", accessor: "tripNo" },
      { Header: "Customer Name", accessor: "customerName" },
      {
        Header: "Status",
        accessor: "status",
        // searchType: "select",
        // selectOptions: statusOptions,
        // placeholder: "All Status",
        cannotSearch: true,
        cannotSort: true,
      },
      { Header: "Qty", accessor: "qty" },
      { Header: "UOM", accessor: "uom" },
      {
        Header: "Date & Time",
        accessor: "dateTime",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      // {
      //   Header: "Action",
      //   accessor: "action",
      //   align: "left",
      //   cannotSearch: true,
      //   cannotSort: true,
      // },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [vinTable, setVinTable] = useState({
    columns: [
      { Header: "VIN", accessor: "vin" },
      { Header: "FG Code", accessor: "fgCode" },
      { Header: "Description", accessor: "Description", width: 320 },
      { Header: "SO / Line", accessor: "soLine" },
      {
        Header: "Status",
        accessor: "status",
        // searchType: "select",
        // selectOptions: statusOptions,
        // placeholder: "All Status",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Release",
        accessor: "release",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Action",
        accessor: "action",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns: itemColumns, rows: itemRows } = vinTable;

  const [tripNo, setTripNo] = useState("");

  useEffect(() => {
    viewAccess &&
      getSalesOrder(
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
  }, [viewAccess, statusSelected, pageNo, rowsPerPage, searchObject]);

  const [loading, setLoading] = useState(true);

  const [vinsData, setVinsData] = useState("");

  useEffect(() => {
    let tempSalesOrder = [];
    let data = salesOrder.salesOrder.data ? salesOrder.salesOrder.data : [];
    setPaginationObj(salesOrder.salesOrder?.pagination);
    setLoading(salesOrder.loading);
    data.map((order) => {
      const formatDate = new Date(order.cd);
      const orderData = {
        salesOrderId: order.salesOrderId,
        salesOrderNumber: order.salesOrderNumber,
        customerName: order.customerName,
        tripNo: order.tripNo,
        status: (
          <button
            type="button"
            className={
              (order.status === 0 && `status-created`) ||
              (order.status === 1 && `status-error`) ||
              (order.status === 3 && `status-success`) ||
              (order.status === 2 && `status-warning`)
            }
            style={{ width: "7rem", cursor: "pointer" }}
            onClick={() => {
              setSalesOrderId(order.salesOrderId);
              setTripNo(order.tripNo);
              setSalesOrderNo(order.salesOrderNumber);
              setSalesOrderDetails(order);
              setVinsData(order);
              handleOpenVinModal(order);
            }}
          >
            {(order.status === 0 && `Created`) ||
              (order.status === 1 && `Not Picked`) ||
              (order.status === 2 && `Picked`) ||
              (order.status === 3 && `Delivered`)}
          </button>
        ),
        qty: `${order.qty}`,
        uom: `${order.uom}`,
        dateTime: order.cd,
      };
      tempSalesOrder.push(orderData);
    });
    setState({ ...state, rows: tempSalesOrder });
  }, [salesOrder]);

  const [downloadData, setDownloadData] = useState([]);

  useEffect(() => {
    let tempSalesOrder = [];
    let data = vinStatus.vins.data ? vinStatus.vins.data : [];

    data.map((order) => {
      const formatDate = new Date(order.cd);
      const orderData = {
        salesOrderId: order.salesOrderId,
        salesOrderNumber: order.salesOrderNumber,
        CustomerName: order.CustomerName,
        tripNo: order.tripNo,
        soLine: `${order.salesOrderNumber} / ${order.salesOrderLineNumber}`,
        status: (
          <button
            type="button"
            className={
              (order.status === 0 && `status-created`) ||
              (order.status === 1 && `status-error`) ||
              (order.status === 3 && `status-success`) ||
              (order.status === 2 && `status-warning`)
            }
            style={{ width: "7rem", cursor: "pointer" }}
            onClick={() => {
              setSalesOrderId(order.salesOrderId);
              setTripNo(order.tripNo);
              setSalesOrderNo(order.salesOrderNumber);
              setSalesOrderDetails(order);
              setVinsData(order);
              handleOpenVinModal(order);
            }}
          >
            {(order.status === 0 && `Created`) ||
              (order.status === 1 && `Not Picked`) ||
              (order.status === 2 && `Picked`) ||
              (order.status === 3 && `Delivered`)}
          </button>
        ),
        qty: `${order.qty}`,
        uom: `${order.uom}`,
        dateTime: order.cd,
        vin: order.vin,
        fgCode: `${order.fgCode} / ${order.fgDescription}`,
      };
      tempSalesOrder.push(orderData);
    });
    setDownloadData(tempSalesOrder);
  }, [vinStatus]);

  const [vinModal, setOpenVinModal] = useState(false);

  const handleOpenVinModal = (order) => {
    getVinStatusByTripNo(order.salesOrderNumber, order.tripNo, jwtToken);
    setTimeout(() => {
      setOpenVinModal(true);
    }, 200);
  };
  const handleCloseVinModal = () => {
    setOpenVinModal(false);
  };

  const [salesOrderId, setSalesOrderId] = useState("");
  const [salesOrderNo, setSalesOrderNo] = useState("");
  const [salesOrderDetails, setSalesOrderDetails] = useState("");

  useEffect(() => {
    let tempVin = [];
    let data = vinsData.vin ? vinsData.vin : [];
    data.map((vin) => {
      let des = vin?.description;
      let len = desLength;
      const vinInfo = {
        vin: vin.vin,
        fgCode: `${vin.fgCode} `,
        Description: (
          <span style={{ display: "flex" }}>
            <MDTypography
              variant="h6"
              fontWeight="regular"
              style={{ fontSize: "14px" }}
            >
              {vin.description ? vin.description.substring(0, len) : ""}
            </MDTypography>
            {vin?.description?.length > 35 && (
              <Tooltip title={vin.description} style={{ marginLeft: "0.1rem" }}>
                ...
              </Tooltip>
            )}
          </span>
        ),

        // fgCode: vin.fgCode,
        tripNo: vin.tripNo,
        soLine: `${vin.salesOrderNumber} / ${vin.salesOrderLineNumber}`,
        customerName: vin.customerName,
        action: (
          <>
            <Tooltip title="Replace Vin">
              <MDButton
                disabled={vin.status > 1 || !replaceVinAccess}
                style={{ marginLeft: "0.5rem" }}
                type="button"
                variant="gradient"
                color="success"
                iconOnly
                onClick={() => {
                  setFgCode(vin.fgCode);
                  handleOpenChangeVinModal(vin);
                  getVinByFgCodeForDispatch(vin.fgCode, jwtToken);
                }}
              >
                {" "}
                <Icon>find_replace</Icon>
              </MDButton>
            </Tooltip>
          </>
        ),
        release: (
          <div>
            {releaseAccess && (
              <ReleaseButton
                tooltip="Release"
                disabled={
                  (vin.isReleasable === 0 && vin.releaseStatus === 0) ||
                  (vin.isReleasable === 1 && vin.releaseStatus === 1)
                }
                variant="gradient"
                color="info"
                iconOnly
                type="button"
                onClick={() => handleOpenReleaseModal(vin)}
                //  style={{ marginRight: "5px" }}
              >
                <Icon>forward</Icon>
              </ReleaseButton>
            )}
          </div>
        ),
        status: (
          <button
            className={
              (vin.status === 0 && `status-created`) ||
              (vin.status === 1 && `status-error`) ||
              (vin.status === 3 && `status-success`) ||
              (vin.status === 2 && `status-warning`)
            }
            style={{ width: "5.5rem" }}
          >
            {(vin.status === 0 && `Created`) ||
              (vin.status === 1 && `Not Picked`) ||
              (vin.status === 2 && `Picked`) ||
              (vin.status === 3 && `Delivered`)}
          </button>
        ),
      };
      tempVin.push(vinInfo);
    });
    setVinTable({
      ...vinTable,
      rows: tempVin,
    });
  }, [vinStatus]);

  const [fgCode, setFgCode] = useState("");

  useEffect(() => {}, [fgCode]);

  const [errorMsg, setErrorMsg] = useState("");

  const [pickListId, setPickListId] = useState("");

  const [changeVinModal, setChangeVinModal] = useState(false);
  const [suidData, setSuidData] = useState(false);
  const [selectedVin, setSelectedVin] = useState("");

  const handleVinChange = (selectedUser) => {
    setSelectedVin(selectedUser);
  };
  const [vinsOptions, setVinsOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getVinByFgCodeForDispatchReducer.vin
      ? getVinByFgCodeForDispatchReducer.vin
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.vin,
        value: document.vin,
      });
    });
    setVinsOptions(tempDocumentTypeOptions);
  }, [getVinByFgCodeForDispatchReducer]);

  const handleOpenChangeVinModal = (vin) => {
    setSelectedVin({
      label: vin.vin,
      value: vin.vin,
    });

    setChangeVinModal(true);
    formik.setValues(initialValuesForChangeVin);
    formik.setTouched({});
    formik.setErrors({});
  };
  const handleCloseChangeVinModal = () => {
    setChangeVinModal(false);
    setSelectedVin("");
  };

  const [isErrorForChangeVin, setIsErrorForChangeVin] = useState(false);
  const [isSuccessForChangeVin, setIsSuccessForChangeVin] = useState(false);

  const initialValuesForChangeVin = {
    vin: "",
  };

  const submitForChangeVin = async (values) => {
    let payload = {
      salesOrderId: singleReleaseData.salesOrderId,
      newVin: selectedVin?.value,
      oldVin: singleReleaseData.vin,
    };

    let res = await changeVin(payload, jwtToken);
    if (res.status) {
      setIsSuccessForChangeVin(true);
      getSalesOrder(
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        setIsSuccessForChangeVin(false);
      }, 3000);
    }
    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg);
      setIsErrorForChangeVin(true);
    }
  };

  const formik = useFormik({
    initialValues: initialValuesForChangeVin,
    onSubmit: submitForChangeVin,
    enableReinitialize: true,
  });
  const [isErrorRelease, setIsErrorRelease] = useState(false);
  const [isSuccessRelease, setIsSuccessRelease] = useState(false);

  useEffect(() => {
    if (isErrorRelease) {
      setTimeout(() => {
        setIsErrorRelease(false);
      }, 3000);
    }
  }, [isErrorRelease]);

  useEffect(() => {
    if (isSuccessRelease) {
      setTimeout(() => {
        setIsSuccessRelease(false);
      }, 3000);
    }
  }, [isSuccessRelease]);

  const [singleReleaseData, setSingleReleaseData] = useState({});

  const [openReleaseModal, setOpenReleaseModal] = useState(false);

  const handleOpenReleaseModal = (asset = {}) => {
    setSingleReleaseData(asset);
    setOpenReleaseModal(true);
  };
  const handleCloseReleaseModal = () => {
    setOpenReleaseModal(false);
  };
  const [isErrorMsgForRelease, setIsErrorMsgForRelease] = useState(false);

  const [releaseName, setReleaseName] = useState("Release");

  const releaseData = async () => {
    setReleaseName("Please wait...");
    let payload = {
      salesOrderId: singleReleaseData.salesOrderId,
      vin: singleReleaseData.vin,
    };

    let response = await releaseTrip(payload, jwtToken);

    if (response.status) {
      setIsSuccessRelease(true);
      getSalesOrder(
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );

      setTimeout(() => {
        handleCloseReleaseModal();
        setReleaseName("Release");
      }, 2250);
    }
    if (!response.status) {
      setIsErrorRelease(true);
      setIsErrorMsgForRelease(
        response?.data?.data?.msg
          ? response?.data?.data?.msg
          : response.data.data.message,
      );
      setReleaseName("Release");
    }
  };
  const [createDispatchModal, setCreateDispatchModal] = useState(false);
  const handleCreateDispatchModal = () => {
    setCreateDispatchModal(!createDispatchModal);
  };

  const initialValues = {
    tripNumber: "",
    tripLineNumber: "",
    itemsForDispatch: [
      {
        salesOrderNumber: "",
        salesOrderLineNumber: "",
        qty: "",
        uom: "",
        customerName: "",
        fgModelId: "",
      },
    ],
  };
  const validationSchema = Yup.object({
    tripNumber: Yup.string().required("Enter the trip no!"),
    tripLineNumber: Yup.string().required("Enter the tripLine no!"),
    itemsForDispatch: Yup.array().of(
      Yup.object({
        qty: Yup.number()
          .min(0, "Quantity cannot be negative")
          .required("Quantity is required"),
      }),
    ),
  });
  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");

  const [isSuccessCreatedDispatch, setIsSuccessCreatedDispatch] =
    useState(false);
  const [isErrorCreatedDispatch, setIsErrorCreatedDispatch] = useState(false);

  useEffect(() => {
    if (isErrorCreatedDispatch) {
      setTimeout(() => {
        setIsErrorCreatedDispatch(false);
      }, 3000);
    }
  }, [isErrorCreatedDispatch]);

  useEffect(() => {
    if (isSuccessCreatedDispatch) {
      setTimeout(() => {
        setIsSuccessCreatedDispatch(false);
      }, 3000);
    }
  }, [isSuccessCreatedDispatch]);

  const [fgCodeOptions, setFgCodeOptions] = useState([]);
  useEffect(() => {
    let tempfgCodeOptions = [];
    let data = getFgCodeNoPaginationReducer.fgCodes
      ? getFgCodeNoPaginationReducer.fgCodes
      : [];

    data.map((warehouse) => {
      tempfgCodeOptions.push({
        label: warehouse.fgModelCode,
        value: warehouse.fgModelId,
        uom: warehouse.uom,
      });
    });
    setFgCodeOptions(tempfgCodeOptions);
  }, [getFgCodeNoPaginationReducer]);
  const [sWarehouseSelected, setSwarehouseSelected] = useState("");

  const handleSwarehouseChange = (selectedOption) => {
    setSwarehouseSelected(selectedOption);
  };

  const [buttonName, setButtonName] = useState("Submit");

  const onSubmitForCreateDispatch = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    const trimmedItemsForDispatch = values.itemsForDispatch.map((item) => {
      // Check each property of the item, and trim if it's a string
      const trimmedItem = {};
      for (const [key, value] of Object.entries(item)) {
        trimmedItem[key] = typeof value === "string" ? value.trim() : value;
      }
      return trimmedItem;
    });

    let payload = {
      tripNumber: values.tripNumber.trim(),
      tripLineNumber: values.tripLineNumber.trim(),
      items: trimmedItemsForDispatch,
    };
    let res = await createDispatch(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreatedDispatch(true);

      getSalesOrder(
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      resetForm();
      setTimeout(() => {
        handleCreateDispatchModal();
        setButtonName("Submit");
      }, 2500);
    }

    if (!res.status) {
      setIsErrorCreatedDispatch(true);
      setErrorMsgForCreate(res?.data?.data?.msg);
      setButtonName("Submit");
    }
  };

  const headersForView = [
    { label: "VIN", key: "vin" },
    { label: "FG Code / Description", key: "fgCode" },
    { label: "SO / Line", key: "soLine" },
    { label: "Trip NUMBER", key: "tripNo" },
    { label: "Customer Name", key: "CustomerName" },
  ];

  const csvLink = {
    filename: "Salesorder wise data.csv",
    headers: headersForView,
    data: downloadData,
  };

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getSalesOrder(
        statusSelected ? statusSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-6}
              >
                <MDBox color="text" px={2} ml={-2} mb={1}>
                  {createAccess && (
                    <CreateButton
                      tooltip="Create Dispatch"
                      // disabled={!createAccess}
                      style={{ marginRight: "1rem" }}
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleCreateDispatchModal();
                        getFgCodeNoPagination(jwtToken);
                      }}
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  )}
                </MDBox>
                {/* } */}
              </MDBox>
              <Grid item xs={12} lg={8} ml={3} mt={1}>
                <MDBox>
                  <MDBox
                    display="flex"
                    mt={2}
                    flexDirection={{ xs: "column", lg: "row" }}
                  >
                    <MDBox
                      width={{ xs: "100%", lg: "250px" }}
                      style={{ marginRight: "10px" }}
                    >
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Status
                      </MDTypography>
                      <Select
                        isClearable
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        placeholder="Choose one..."
                        autoComplete="off"
                        value={statusSelected}
                        options={statusOptions}
                        onChange={handleStatusChange}
                      />
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid>
              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
              <Modal
                open={vinModal}
                onClose={handleCloseVinModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      spacing={10}
                      mb={2}
                    >
                      <MDBox display="flex" flexDirection="column">
                        <MDTypography
                          variant="h5"
                          fontWeight="medium"
                          flexGrow={1}
                          fontSize={{ xs: "14px", lg: "18px" }}
                        >
                          Trip Number:-{" "}
                          <span style={{ fontWeight: 400 }}>{tripNo}</span>
                        </MDTypography>
                        <MDTypography
                          variant="h5"
                          fontWeight="medium"
                          flexGrow={1}
                          fontSize={{ xs: "14px", lg: "18px" }}
                        >
                          Customer Name:-{" "}
                          <span style={{ fontWeight: 400 }}>
                            {salesOrderDetails?.customerName}
                          </span>
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    <MDBox></MDBox>
                    <MDBox display="flex" marginLeft="auto">
                      <span>
                        <Tooltip title="Close">
                          <IconButton
                            style={{
                              display: "flex",
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "auto",
                              marginBottom: "5px",
                              marginRight: "10px",
                            }}
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseVinModal}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />
                  <MDBox>
                    {downloadAllDataAccess && (
                      <CSVLink {...csvLink}>
                        <DownloadDataButton
                          tooltip="Download list"
                          style={{ marginLeft: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="success"
                          iconOnly
                        >
                          <Icon>download</Icon>
                        </DownloadDataButton>
                      </CSVLink>
                    )}
                    <DataTable
                      table={{ columns: itemColumns, rows: itemRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={changeVinModal}
                onClose={handleCloseChangeVinModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForChangeVin}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Replace Vin
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseChangeVinModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <MDBox mb={1}>
                        <MDTypography
                          variant="h6"
                          style={{ fontWeight: "500" }}
                        >
                          {" "}
                          Vin
                        </MDTypography>

                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="vin"
                          onBlur={() => {
                            formik.handleBlur({
                              target: { name: "vin" },
                            });
                          }}
                          value={selectedVin}
                          options={vinsOptions}
                          onChange={(selectedOption) => {
                            handleVinChange(selectedOption);
                            formik.setFieldValue("vin", selectedOption);
                          }}
                        />
                        {formik.touched.vin && formik.errors.vin && (
                          <TextError msg={formik.errors.vin} />
                        )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForChangeVin}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForChangeVin(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForChangeVin}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForChangeVin(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Vin Changed Successfully
                          </Alert>
                        </Collapse>
                      </MDBox>

                      <MDBox mt={3}>
                        <MDButton
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openReleaseModal}
                onClose={handleCloseReleaseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={releaseStyle}>
                  <MDTypography>Are you sure you want to Release?</MDTypography>
                  <MDBox mt={2} display="flex">
                    <div>
                      <MDButton
                        style={{ width: "100%", marginRight: "1.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseReleaseModal}
                      >
                        Cancel
                      </MDButton>
                    </div>
                    <div style={{ float: "right" }}>
                      <MDButton
                        style={{ width: "100%", marginLeft: "0.5rem" }}
                        color="info"
                        onClick={releaseData}
                        disabled={releaseName === "Please wait..."}
                      >
                        {releaseName}
                      </MDButton>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessRelease}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessRelease(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Trip Releaseed successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorRelease}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorRelease(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForRelease}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={createDispatchModal}
                onClose={handleCreateDispatchModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCreate}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Create Trip
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateDispatchModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox>
                      <MDBox>
                        <Grid container>
                          <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmitForCreateDispatch}
                          >
                            {(formik) => {
                              return (
                                <Form>
                                  <div>
                                    <MDBox>
                                      <Grid container>
                                        <Grid item xs={10} lg={6}>
                                          <MDBox
                                            mb={1}
                                            ml={1}
                                            style={{
                                              width: {
                                                xs: "200px",
                                                lg: "370px",
                                              },
                                            }}
                                          >
                                            <MDTypography
                                              variant="h6"
                                              style={{ fontWeight: "500" }}
                                            >
                                              Trip No
                                            </MDTypography>
                                            <Field
                                              className="form-control"
                                              type="text"
                                              name="tripNumber"
                                              fullWidth
                                              autoComplete="off"
                                              onChange={formik.handleChange}
                                              value={formik.values.tripNumber}
                                              error={
                                                formik.touched.tripNumber &&
                                                formik.errors.tripNumber &&
                                                true
                                              }
                                              inputProps={{
                                                style: { height: "14px" },
                                                maxLength: 45,
                                              }}
                                            />
                                            {formik.touched.tripNumber &&
                                              formik.errors.tripNumber && (
                                                <TextError
                                                  msg={formik.errors.tripNumber}
                                                />
                                              )}
                                          </MDBox>
                                        </Grid>
                                        <Grid item xs={10} lg={6}>
                                          <MDBox
                                            mb={1}
                                            ml={1}
                                            style={{
                                              width: {
                                                xs: "200px",
                                                lg: "370px",
                                              },
                                            }}
                                          >
                                            <MDTypography
                                              variant="h6"
                                              style={{ fontWeight: "500" }}
                                            >
                                              Trip LineNumberNo
                                            </MDTypography>
                                            <Field
                                              className="form-control"
                                              type="text"
                                              name="tripLineNumber"
                                              fullWidth
                                              autoComplete="off"
                                              onChange={formik.handleChange}
                                              value={
                                                formik.values.tripLineNumber
                                              }
                                              error={
                                                formik.touched.tripLineNumber &&
                                                formik.errors.tripLineNumber &&
                                                true
                                              }
                                              inputProps={{
                                                style: {
                                                  height: "14px",
                                                },
                                                maxLength: 45,
                                              }}
                                            />
                                            {formik.touched.tripLineNumber &&
                                              formik.errors.tripLineNumber && (
                                                <TextError
                                                  msg={
                                                    formik.errors.tripLineNumber
                                                  }
                                                />
                                              )}
                                          </MDBox>
                                        </Grid>
                                      </Grid>
                                    </MDBox>
                                    <MDBox>
                                      <MDTypography variant="h5">
                                        Items
                                      </MDTypography>
                                      <hr style={{ marginBottom: "10px" }} />

                                      <FieldArray name="itemsForDispatch">
                                        {(fieldArrayProps) => {
                                          const { push, remove, form } =
                                            fieldArrayProps;
                                          const { values } = form;
                                          const { itemsForDispatch } = values;

                                          return (
                                            <div>
                                              {itemsForDispatch.map(
                                                (item, index) => {
                                                  return (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                      key={index}
                                                    >
                                                      <Grid container>
                                                        <Grid
                                                          item
                                                          xs={10}
                                                          lg={3}
                                                        >
                                                          <MDBox mb={1} ml={1}>
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Sales Order No
                                                            </MDTypography>
                                                            <Field
                                                              className="form-control"
                                                              type="text"
                                                              name={`itemsForDispatch[${index}].salesOrderNumber`}
                                                              fullWidth
                                                              autoComplete="off"
                                                              value={
                                                                itemsForDispatch.salesOrderNumber
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                },
                                                                maxLength: 45,
                                                              }}
                                                            />
                                                          </MDBox>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={10}
                                                          lg={3}
                                                        >
                                                          <MDBox mb={1} ml={1}>
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Sales Order Line
                                                              No
                                                            </MDTypography>
                                                            <Field
                                                              className="form-control"
                                                              type="text"
                                                              name={`itemsForDispatch[${index}].salesOrderLineNumber`}
                                                              fullWidth
                                                              autoComplete="off"
                                                              value={
                                                                itemsForDispatch.salesOrderLineNumber
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                },
                                                                maxLength: 45,
                                                              }}
                                                            />
                                                          </MDBox>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={10}
                                                          lg={3}
                                                        >
                                                          <MDBox mb={1} ml={1}>
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Customer Name
                                                            </MDTypography>
                                                            <Field
                                                              className="form-control"
                                                              type="text"
                                                              name={`itemsForDispatch[${index}].customerName`}
                                                              fullWidth
                                                              autoComplete="off"
                                                              value={
                                                                itemsForDispatch.customerName
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                },
                                                                maxLength: 45,
                                                              }}
                                                            />
                                                          </MDBox>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={10}
                                                          lg={3}
                                                        >
                                                          <MDBox mb={1} ml={1}>
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              Qty
                                                            </MDTypography>
                                                            <Field
                                                              className="form-control"
                                                              type="number"
                                                              name={`itemsForDispatch[${index}].qty`}
                                                              fullWidth
                                                              autoComplete="off"
                                                              value={
                                                                formik.values
                                                                  .itemsForDispatch[
                                                                  index
                                                                ].qty
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                },
                                                                maxLength: 45,
                                                              }}
                                                            />
                                                            {formik.touched
                                                              .itemsForDispatch &&
                                                              formik.touched
                                                                .itemsForDispatch[
                                                                index
                                                              ] &&
                                                              formik.touched
                                                                .itemsForDispatch[
                                                                index
                                                              ].qty &&
                                                              formik.errors
                                                                .itemsForDispatch &&
                                                              formik.errors
                                                                .itemsForDispatch[
                                                                index
                                                              ] &&
                                                              formik.errors
                                                                .itemsForDispatch[
                                                                index
                                                              ].qty && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .itemsForDispatch[
                                                                      index
                                                                    ].qty
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>

                                                        <Grid
                                                          item
                                                          xs={10}
                                                          lg={3}
                                                        >
                                                          <MDBox
                                                            mb={1}
                                                            ml={1}
                                                            style={{
                                                              width: "192px",
                                                            }}
                                                          >
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              FG Code
                                                            </MDTypography>
                                                            <Select
                                                              isClearable
                                                              className="select-css"
                                                              maxMenuHeight={
                                                                230
                                                              }
                                                              menuPlacement="top"
                                                              menuPosition="absolute"
                                                              placeholder="Choose one..."
                                                              name={`itemsForDispatch[${index}].fgModelId`}
                                                              onBlur={() => {
                                                                formik.handleBlur(
                                                                  {
                                                                    target: {
                                                                      name: `itemsForDispatch[${index}].fgModelId`,
                                                                    },
                                                                  },
                                                                );
                                                              }}
                                                              options={
                                                                fgCodeOptions
                                                              }
                                                              value={
                                                                itemsForDispatch.fgModelId
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                if (
                                                                  selectedOption
                                                                ) {
                                                                  const selectedItem =
                                                                    fgCodeOptions.find(
                                                                      (
                                                                        option,
                                                                      ) =>
                                                                        option.value ===
                                                                        selectedOption.value,
                                                                    );
                                                                  if (
                                                                    selectedItem
                                                                  ) {
                                                                    formik.setFieldValue(
                                                                      `itemsForDispatch.${index}.fgModelId`,
                                                                      selectedOption.value,
                                                                    );
                                                                    formik.setFieldValue(
                                                                      `itemsForDispatch.${index}.uom`,
                                                                      selectedItem.uom,
                                                                    );
                                                                  }
                                                                } else {
                                                                  formik.setFieldValue(
                                                                    `itemsForDispatch.${index}.uom`,
                                                                    "",
                                                                  );
                                                                }
                                                              }}
                                                            />
                                                            {formik.touched
                                                              .itemsForDispatch &&
                                                              formik.errors
                                                                .itemsForDispatch &&
                                                              formik.errors
                                                                .itemsForDispatch[
                                                                index
                                                              ] &&
                                                              formik.errors
                                                                .itemsForDispatch[
                                                                index
                                                              ].fgModelId && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .itemsForDispatch[
                                                                      index
                                                                    ].fgModelId
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={10}
                                                          lg={3}
                                                        >
                                                          <MDBox mb={1} ml={1}>
                                                            <MDTypography
                                                              variant="h6"
                                                              style={{
                                                                fontWeight:
                                                                  "500",
                                                              }}
                                                            >
                                                              UOM
                                                            </MDTypography>
                                                            <Field
                                                              disabled
                                                              className="form-control"
                                                              type="text"
                                                              name={`itemsForDispatch[${index}].uom`}
                                                              fullWidth
                                                              autoComplete="off"
                                                              value={
                                                                formik.values
                                                                  .itemsForDispatch[
                                                                  index
                                                                ]?.uom
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "14px",
                                                                  readOnly: true,
                                                                },
                                                                maxLength: 45,
                                                              }}
                                                            />
                                                          </MDBox>
                                                        </Grid>

                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            marginTop: "1.5rem",
                                                            marginLeft: "2rem",
                                                          }}
                                                        >
                                                          <div className="col">
                                                            {index > 0 && (
                                                              <CancelIcon
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                type="button"
                                                                className="secondary"
                                                                onClick={() =>
                                                                  remove(index)
                                                                }
                                                                color="error"
                                                              />
                                                            )}
                                                          </div>
                                                          {index ===
                                                            itemsForDispatch.length -
                                                              1 && (
                                                            <div>
                                                              <Tooltip title="Add Items">
                                                                <AddCircleIcon
                                                                  fontSize="large"
                                                                  onClick={() =>
                                                                    push({
                                                                      salesOrderNumber:
                                                                        "",
                                                                      salesOrderLineNumber:
                                                                        "",
                                                                      qty: "",
                                                                      uom: "",
                                                                      customerName:
                                                                        "",
                                                                      fgModelId:
                                                                        "",
                                                                    })
                                                                  }
                                                                  color="info"
                                                                  style={{
                                                                    width:
                                                                      "30px",
                                                                    marginLeft:
                                                                      "0rem",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                />
                                                              </Tooltip>
                                                            </div>
                                                          )}
                                                        </span>
                                                      </Grid>
                                                    </div>
                                                  );
                                                },
                                              )}
                                            </div>
                                          );
                                        }}
                                      </FieldArray>
                                    </MDBox>

                                    <div style={{ background: "white" }}>
                                      <MDButton
                                        style={{
                                          position: "sticky",
                                          bottom: "0",
                                        }}
                                        color="info"
                                        fullWidth
                                        type="submit"
                                        disabled={
                                          !formik.isValid ||
                                          formik.values.itemsForDispatch.some(
                                            (item) => item.fgModelId === "",
                                          ) ||
                                          buttonName === "Please wait..."
                                        }
                                      >
                                        {buttonName}
                                      </MDButton>
                                    </div>
                                    <MDBox>
                                      <Collapse in={isErrorCreatedDispatch}>
                                        <Alert
                                          severity="error"
                                          action={
                                            <IconButton
                                              aria-label="close"
                                              color="inherit"
                                              size="small"
                                              onClick={() => {
                                                setIsErrorCreatedDispatch(
                                                  false,
                                                );
                                              }}
                                            >
                                              <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                          }
                                        >
                                          {errorMsgForCreate}
                                        </Alert>
                                      </Collapse>
                                      <Collapse in={isSuccessCreatedDispatch}>
                                        <Alert
                                          severity="success"
                                          action={
                                            <IconButton
                                              aria-label="close"
                                              color="inherit"
                                              size="small"
                                              onClick={() => {
                                                setIsSuccessCreatedDispatch(
                                                  false,
                                                );
                                              }}
                                            >
                                              <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                          }
                                        >
                                          Created Successfully
                                        </Alert>
                                      </Collapse>
                                    </MDBox>
                                  </div>
                                </Form>
                              );
                            }}
                          </Formik>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Footer />
      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    salesOrder: state.salesOrder,
    vinStatus: state.vinStatus,
    accessoriesByVin: state.accessoriesByVin,
    getVinByFgCodeForDispatchReducer: state.getVinByFgCodeForDispatchReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getFgCodeReducer: state.getFgCodeReducer,
    getFgCodeNoPaginationReducer: state.getFgCodeNoPaginationReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getSalesOrder: (status, pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getSalesOrder(status, pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    getFgCode: (jwtToken) => dispatch(getFgCode(jwtToken)),
    getFgCodeNoPagination: (jwtToken) =>
      dispatch(getFgCodeNoPagination(jwtToken)),
    getVinStatusByTripNo: (salesOrder, tripNo, jwtToken) =>
      dispatch(getVinStatusByTripNo(salesOrder, tripNo, jwtToken)),
    approveVin: (payload) => dispatch(approveVin(payload)),
    releaseTrip: (payload, jwtToken) =>
      dispatch(releaseTrip(payload, jwtToken)),
    createDispatch: (payload, jwtToken) =>
      dispatch(createDispatch(payload, jwtToken)),
    changeVin: (payload, jwtToken) => dispatch(changeVin(payload, jwtToken)),
    getAccessoriesByVin: (vin, jwtToken) =>
      dispatch(getAccessoriesByVin(vin, jwtToken)),
    getVinByFgCodeForDispatch: (fgCode, jwtToken) =>
      dispatch(getVinByFgCodeForDispatch(fgCode, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dispatch);
